var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-select"},[_c('b-form-group',{class:{
            'required-field': _vm.field.isRequired,
        },attrs:{"label-for":`id_${_vm.field._id}`}},[_c('label',{class:{
                'urdu-label': _vm.urduLabel,
            }},[_vm._v(_vm._s(_vm.field.label))]),_c('multiselect',{directives:[{name:"validate",rawName:"v-validate",value:({
                required: _vm.field.isRequired,
            }),expression:"{\n                required: field.isRequired,\n            }"}],class:{
                'is-invalid': _vm.errors.has(_vm.field.label),
            },attrs:{"tag-placeholder":"field.placeholder","placeholder":_vm.field.placeholder,"label":"title","track-by":"title","options":_vm.field.options,"multiple":true,"data-vv-name":_vm.field.label,"taggable":true,"disabled":_vm.loading || _vm.isDisable},on:{"input":_vm.setModelValue},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }